exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  border: solid 1px var(--color-border); }\n  :host nav {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    cursor: pointer; }\n    :host nav > * {\n      -ms-flex: 1;\n          flex: 1;\n      height: 5rem;\n      line-height: 5rem;\n      text-align: center;\n      color: var(--color-primary);\n      border-color: var(--color-border);\n      border-style: solid;\n      border-width: 0; }\n      :host nav > *:not(:last-child) {\n        border-right-width: 1px; }\n      :host nav > *:not(.active) {\n        border-bottom-width: 1px;\n        background-color: var(--background-color);\n        color: var(--color-secondary); }\n  :host .container {\n    position: relative; }\n    :host .container /deep/ > div {\n      min-height: 30rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/tabs/tabs.component.scss
// module id = ../../../../../src/app/ui-shared/tabs/tabs.component.scss
// module chunks = main